import React from 'react';
import Text from '../text/Text';

import { numberToBengali } from '../../utils/convertToBengaliNumber';

function MobileView({
  activePage,
  totalPage,
  language,
}: {
  activePage: number;
  totalPage: number;
  language: string;
}) {
  const count =
    language === 'bn'
      ? `${numberToBengali(totalPage)} এর মধ্যে ${numberToBengali(
          activePage,
        )} নং পৃষ্ঠা`
      : `Page ${activePage} of ${totalPage}`;

  return (
    <Text weight="medium" color="title">
      {count}
    </Text>
  );
}

export default MobileView;
